import pkg from '../../package.json'

export const LANG_COOKIE_NAME = `${pkg.soveluss.uuid}-lang`

export const AUTH_SCOPE = ['email', 'profile', 'openid']

export const AUTH_RESPONSE_TYPE = 'code'
